import { Building2, Cpu } from "lucide-react";

export default function CompanySection() {
  return (
    <section
      id="company"
      className="relative py-16 md:py-32 bg-[#0A0B0E]"
      data-testid="company-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Quem Somos
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Quem está <span className="text-[#F59E0B]">por trás</span>
          </h2>
        </div>

        {/* Company Card */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                <Building2 className="h-7 w-7 text-[#F59E0B]" />
              </div>
              <div>
                <h3 className="font-heading text-2xl font-bold text-[#E5E7EB]">
                  EVIDENTIA TECNOLOGIA LTDA
                </h3>
                <p className="text-sm font-mono text-[#9CA3AF]">
                  CNPJ: 65.097.807/0001-30
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-[#0F1115] p-6 rounded-sm border border-[#2A2F38]">
              <Cpu className="h-5 w-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
              <p className="text-[#9CA3AF]">
                Empresa especializada em desenvolvimento de{" "}
                <span className="text-[#E5E7EB]">
                  soluções estruturadas de inteligência aplicada.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
